import type { ReactNode } from 'react';
import { useTheme, useApplyTheme } from '@/hooks/useTheme';

/** Subscribes to the theme store and applies the right class to <html>. */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const { mode } = useTheme();
  useApplyTheme(mode);
  return <>{children}</>;
}
